import { forwardRef, type ComponentProps, type FC } from 'react';

import { getClassNames } from '@eneco/sparky/util/css';
import { Polygon, Line as VisxLine } from '@visx/shape';
import { Text as VisxText } from '@visx/text';

import {
  controlsContainerClass,
  graphTextClass,
  invisibleHoverAreaClass,
  lineDashedClass,
  lineRegularClass,
  scrollContainerClass,
  styledPathCheapClass,
  styledPathClass,
  styledPathExpensiveClass,
} from './Graph.css';

export const InvisibleHoverArea: FC<ComponentProps<typeof Polygon>> = ({ className, ...props }) => (
  <Polygon {...props} className={getClassNames(invisibleHoverAreaClass, className)} />
);

export const Text: FC<ComponentProps<typeof VisxText>> = ({ className, ...props }) => (
  <VisxText {...props} className={getClassNames(graphTextClass, className)} />
);

type LineType = 'regular' | 'dashed';
type LineProps = Omit<ComponentProps<typeof VisxLine>, 'type'> & { type?: LineType };

export const Line: FC<LineProps> = ({ className, type = 'regular', ...props }) => (
  <VisxLine {...props} className={getClassNames(type === 'dashed' ? lineDashedClass : lineRegularClass, className)} />
);

export const ScrollContainer = forwardRef<HTMLDivElement, ComponentProps<'div'>>(({ className, ...props }, ref) => (
  <div {...props} ref={ref} className={getClassNames(scrollContainerClass, className)} />
));

export const ControlsContainer: FC<ComponentProps<'div'>> = ({ className, ...props }) => (
  <div {...props} className={getClassNames(controlsContainerClass, className)} />
);

type StyledPathType = 'cheap' | 'expensive';
type StyledPathProps = Omit<ComponentProps<'path'>, 'type'> & { type?: StyledPathType };

export const StyledPath: FC<StyledPathProps> = ({ className, type = 'cheap', ...props }) => (
  <path
    {...props}
    className={getClassNames(
      styledPathClass,
      type === 'expensive' ? styledPathExpensiveClass : styledPathCheapClass,
      className,
    )}
  />
);
